/* LA008 only. Static content controls; canonical subscription module is page-local. */
(() => {
  'use strict';
  const root = document.getElementById('la008');
  if (!root) return;
  // Start each visible original once. Never restart after a user pause or on scroll.
  const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
  const attempted=new WeakSet();
  const originalVideos=[...root.querySelectorAll('video[data-original-figma-video]')];
  const start=video=>{
    if(motion.matches||attempted.has(video)||!video.getBoundingClientRect().width)return;
    attempted.add(video);video.muted=true;video.playsInline=true;
    const play=video.play();if(play&&play.catch)play.catch(()=>{video.dataset.autoplayBlocked='true';});
  };
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting)start(entry.target);}),{threshold:0.15});
  originalVideos.forEach(video=>{video.addEventListener('play',()=>attempted.add(video));observer.observe(video);});
  motion.addEventListener('change',event=>{if(event.matches)originalVideos.forEach(video=>video.pause());});

  root.querySelectorAll('main').forEach((main, mainIndex) => {
    main.querySelectorAll('.la008-review-viewport').forEach(rail=>{
      const root = rail.closest('[data-name="Customer quotes"], [data-name="Customer reviews"], .la008-n989, .la008-n291, .la008-n959') || rail.parentElement;
      const inset=()=>{
        const first=rail.children[0];
        if(!first) return 0;
        const ml=parseFloat(getComputedStyle(first).marginLeft)||0;
        return ml>0?ml:17;
      };
      const step=()=>rail.children[0].getBoundingClientRect().width+(parseFloat(getComputedStyle(rail).columnGap)||parseFloat(getComputedStyle(rail).gap)||0);
      const dots=[...root.querySelectorAll('[data-review-slide]')];
      const go=(i)=>{
        const max=Math.max(0, rail.children.length-1);
        const idx=Math.max(0, Math.min(max, i));
        const el=rail.children[idx];
        const left=el?Math.max(0, el.offsetLeft - inset()):step()*idx;
        rail.scrollTo({left, behavior:'instant'});
        dots.forEach((d,di)=>d.setAttribute('aria-current', String(di===idx)));
      };
      const move=n=>{
        const base=inset();
        const cur=Math.round((rail.scrollLeft)/Math.max(1,step()));
        go(cur+n);
      };
      root.querySelectorAll('[data-review-step]').forEach(b=>b.addEventListener('click',()=>move(Number(b.dataset.reviewStep))));
      dots.forEach(d=>d.addEventListener('click',()=>go(Number(d.dataset.reviewSlide))));
      rail.addEventListener('scroll',()=>{
        const idx=Math.round(rail.scrollLeft/Math.max(1,step()));
        dots.forEach((d,di)=>d.setAttribute('aria-current', String(di===idx)));
      }, {passive:true});
      rail.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}});
      // Kill padding-canceling scroll (Chrome snap was leaving scrollLeft≈17 → card at x=0)
      rail.scrollLeft=0;
      requestAnimationFrame(()=>{rail.scrollLeft=0;});
    });
    main.querySelectorAll('.la008-video-viewport').forEach(videos=>{
      const root = videos.closest('[data-name], .la008-mobile, .la008-desktop') || main;
      const dots=[...root.querySelectorAll('[data-video-slide]')];
      // Dual-side peeks (Figma 24130:3078): clone last before first + first after last; center active
      if(main.classList.contains('la008-mobile') && !videos.dataset.la008VideoCloned){
        const kids=[...videos.children].filter(el=>el.nodeType===1 && getComputedStyle(el).display!=='none');
        if(kids.length>=2){
          const first=kids[0], last=kids[kids.length-1];
          const pre=last.cloneNode(true); pre.setAttribute('data-la008-clone','pre'); pre.setAttribute('aria-hidden','true');
          const post=first.cloneNode(true); post.setAttribute('data-la008-clone','post'); post.setAttribute('aria-hidden','true');
          // clones must not re-trigger original video autoplay observers uniquely — strip data-original if present deep
          pre.querySelectorAll('video').forEach(v=>{v.removeAttribute('data-original-figma-video'); v.muted=true; v.playsInline=true;});
          post.querySelectorAll('video').forEach(v=>{v.removeAttribute('data-original-figma-video'); v.muted=true; v.playsInline=true;});
          videos.insertBefore(pre, first);
          videos.appendChild(post);
          videos.dataset.la008VideoCloned='1';
        }
      }
      const realCount=()=>[...videos.children].filter(el=>!el.hasAttribute('data-la008-clone')).length;
      const step=()=>{
        const el=[...videos.children].find(c=>!c.hasAttribute('data-la008-clone'))||videos.children[0];
        return el.getBoundingClientRect().width+(parseFloat(getComputedStyle(videos).columnGap)||parseFloat(getComputedStyle(videos).gap)||0);
      };
      const centerOn=(domIndex, behavior='instant')=>{
        const el=videos.children[domIndex];
        if(!el) return;
        const left=el.offsetLeft - (videos.clientWidth - el.getBoundingClientRect().width)/2;
        videos.scrollTo({left:Math.max(0,left), behavior});
      };
      const syncDots=()=>{
        const s=step();
        const mid=videos.scrollLeft + videos.clientWidth/2;
        let best=0, bestDist=Infinity;
        [...videos.children].forEach((el,i)=>{
          if(el.hasAttribute('data-la008-clone')) return;
          const cx=el.offsetLeft + el.getBoundingClientRect().width/2;
          const d=Math.abs(cx - (videos.scrollLeft + videos.clientWidth/2));
          if(d<bestDist){bestDist=d; best=i;}
        });
        // map dom index to real index
        const clonesBefore=[...videos.children].slice(0,best).filter(el=>el.hasAttribute('data-la008-clone')).length;
        const realIdx=Math.max(0, best - clonesBefore);
        dots.forEach((dot,i)=>dot.setAttribute('aria-current', String(i===realIdx)));
        return {best, realIdx};
      };
      dots.forEach((dot,i)=>dot.addEventListener('click',()=>{
        // real i → dom index (+1 if pre-clone)
        const hasPre=videos.querySelector('[data-la008-clone="pre"]');
        centerOn((hasPre?1:0)+i);
        dots.forEach((d,di)=>d.setAttribute('aria-current', String(di===i)));
      }));
      let snapTimer=null;
      videos.addEventListener('scroll',()=>{
        clearTimeout(snapTimer);
        snapTimer=setTimeout(()=>{
          const hasPre=!!videos.querySelector('[data-la008-clone="pre"]');
          const hasPost=!!videos.querySelector('[data-la008-clone="post"]');
          const n=realCount();
          const s=step();
          // if parked on clones, jump to real counterpart
          const firstReal=hasPre?1:0;
          const lastReal=firstReal+n-1;
          const approx=Math.round(videos.scrollLeft/Math.max(1,s));
          if(hasPre && approx<=0){ centerOn(lastReal); }
          else if(hasPost && approx>=lastReal+1){ centerOn(firstReal); }
          syncDots();
        }, 80);
        syncDots();
      },{passive:true});
      videos.addEventListener('keydown',event=>{
        if(event.target!==videos)return;
        if(event.key==='ArrowRight'||event.key==='ArrowLeft'){
          event.preventDefault();
          const dir=event.key==='ArrowRight'?1:-1;
          const hasPre=!!videos.querySelector('[data-la008-clone="pre"]');
          const n=realCount();
          const cur=syncDots().realIdx;
          const next=(cur+dir+n)%n;
          centerOn((hasPre?1:0)+next);
        }
      });
      const hasPre=!!videos.querySelector('[data-la008-clone="pre"]');
      // Figma starts with slide 1 (i.12) centered — first REAL slide — peeks both sides via pre-clone
      const boot=()=>{ centerOn(hasPre?1:0); if(dots[0]) dots.forEach((d,i)=>d.setAttribute('aria-current', String(i===0))); };
      boot();
      requestAnimationFrame(boot);
      setTimeout(boot, 50);
    })
    /* Tasnim: hamburger + search visible but not clickable; logo/cart untouched */
    const lockNav = () => {
      main.querySelectorAll('[data-menu-toggle]').forEach(toggle => {
        toggle.setAttribute('aria-disabled', 'true');
        toggle.setAttribute('tabindex', '-1');
        toggle.style.pointerEvents = 'none';
        toggle.setAttribute('data-quia-nav-disabled', '');
      });
      main.querySelectorAll('a[aria-label="Search"], a[href="/search"], a[data-la008-nav-inert]').forEach(a => {
        a.setAttribute('aria-disabled', 'true');
        a.setAttribute('tabindex', '-1');
        a.style.pointerEvents = 'none';
      });
    };
    lockNav();
    setTimeout(lockNav, 0);
    setTimeout(lockNav, 500);
    setTimeout(lockNav, 1500);
    main.addEventListener('click', event => {
      const t = event.target.closest('[data-menu-toggle], a[aria-label="Search"], a[href="/search"], a[data-la008-nav-inert]');
      if (!t || !main.contains(t)) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);
    const thumbs=[...main.querySelectorAll('[data-thumbnail]')];
    const holder=main.querySelector('[data-name="image 62581"]');
    const display=holder?.querySelector('img');
    if(display && thumbs.length){
      let index=0;
      const original={src:display.src,alt:display.alt};
      const show=(next)=>{
        index=(next+thumbs.length)%thumbs.length;
        const thumb=thumbs[index].querySelector('img');
        display.src=index===0?original.src:(thumbs[index].dataset.gallerySrc||thumb.src);
        display.alt=`Quia product gallery image ${index+1}`;
        holder.classList.toggle('la008-gallery-alternate',index!==0);
        thumbs.forEach((button,i)=>{button.setAttribute('aria-pressed',String(i===index));});
        thumbs[index].scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});
      };
      thumbs.forEach((button,i)=>{
        button.setAttribute('aria-pressed',String(i===0));
        button.addEventListener('click',()=>show(i));
        button.addEventListener('keydown',event=>{
          if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();show(index+(event.key==='ArrowRight'?1:-1));thumbs[index].focus();}
        });
      });
      const arrows=[...main.querySelectorAll('[data-gallery-prev]')];
      arrows.forEach((button,i)=>{button.setAttribute('aria-label',`${i?'Next':'Previous'} product image`);button.addEventListener('click',()=>show(index+(i?1:-1)));});
      const rail=thumbs[0].parentElement;
      rail.classList.add('la008-thumbnail-rail');
    }
    main.querySelectorAll('details').forEach(details=>details.addEventListener('toggle',()=>{
      const mark=details.querySelector('summary > :last-child');if(mark)mark.textContent=details.open?'−':'+';
    }));
  });
})();

/* LA008_FAQ_ONE_OPEN_0124 (Tasnim direct): only one FAQ open at a time */
document.addEventListener('toggle',function(e){var d=e.target;if(!d||!d.matches||!d.matches('#la008 details.la008-faq')||!d.open)return;var box=d.parentElement;box&&box.querySelectorAll('details.la008-faq[open]').forEach(function(o){if(o!==d)o.open=false;});},true);
/* LA008-REVIEWS-UGC-FIX-20261101 */
